import { useState } from 'react'
import { TrashIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ConfirmationDialog } from '@/components/confirmation-dialog'
import { useDeleteServerInstance } from '@/services/server'

export const DeleteServerDialog = ({
  instanceId,
  serverName,
  onDeleteConfirm,
}: {
  instanceId: number
  serverName: string
  onDeleteConfirm?: () => void
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const { mutateAsync: deleteServerMutation, isPending } =
    useDeleteServerInstance()

  return (
    <>
      <Button
        variant="outline-destructive"
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-2"
      >
        <TrashIcon className="h-4 w-4" />
        Delete
      </Button>

      <ConfirmationDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        title="Delete Server"
        description="You are about to delete this server instance. This action cannot be undone."
        buttons={{
          confirm: {
            label: 'Delete',
            isDestructive: true,
            isLoading: isPending,
          },
        }}
        confirmation={{
          text: serverName,
          prompt: `Please type "${serverName}" below to confirm this action:`,
        }}
        info={{
          warningPoints: [
            'This action is destructive and cannot be undone.',
            'All running tasks will terminate immediately.',
            'Any data stored in ephemeral storage space will be permanently deleted.',
          ],
        }}
        onConfirm={() =>
          deleteServerMutation(instanceId, {
            onSuccess: () => {
              onDeleteConfirm?.()
              setIsOpen(false)
            },
          })
        }
      />
    </>
  )
}
